<template>
	<div id="app">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // 👇 添加全局 nativeCallbackHandler 回调函数
    // window.nativeCallbackHandler = function (type, payload) {
    //   switch (type) {
    //     case 'error':
    //       alert('错误信息: ' + JSON.stringify(payload));
    //       break;
    //     case 'info':
    //       alert('信息: ' + JSON.stringify(payload));
    //       break;
    //     default:
    //       alert('其他: ' + JSON.stringify(payload));
    //   }
    // };
    console.log("✅ nativeCallbackHandler 已挂载到 window");
  }
};
</script>

<style>
@font-face {
	font-family: "Nunito_Sans";
	src: url("./assets/font/NunitoSans.ttf");
}

* {
	box-sizing: border-box;
	/* font-family: 'Nunito_Sans'; */
}
.yinshouTable .total-cell {
	background-color: #c5c5c5 !important;
	color: white !important;
}
.yinshouTable > .el-table--enable-row-hover .el-table__body tr:hover > td:not(.total-cell) {
  background-color: transparent !important;
}
::-webkit-scrollbar {
	width: 0;
}

::-webkit-scrollbar {
	width: 0;
	height: 0;
}


html {
	overflow: hidden;
}

body {
	padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue